import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Paper, Stepper, Step, StepLabel, StepContent, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(4)
	},
	header: {
		marginBottom: theme.spacing(4)
	},
	stepper: {
		backgroundColor: 'transparent'
	}
}));

const defaultSteps = [
	{
		label: 'Explore Applications',
		description: 'Browse our library of free applications available in your demo account.'
	},
	{
		label: 'Launch Your First App',
		description: 'Try Heroic Game Day or BrainChild Learning Platform to see the platform in action.'
	},
	{
		label: 'Discover More Features',
		description: 'Explore other platform capabilities and see what\'s included with a full Heidi subscription.'
	}
];

function GettingStarted({ config = {}, branding = {} }) {
	const classes = useStyles();

	const {
		title = 'Getting Started Guide',
		subtitle = 'Follow these steps to make the most of your demo experience',
		steps = defaultSteps
	} = config;

	return (
		<Paper className={classes.root}>
			<div className={classes.header}>
				<Typography variant="h3" gutterBottom>
					{title}
				</Typography>
				<Typography variant="h6" color="textSecondary">
					{subtitle}
				</Typography>
			</div>

			<Stepper orientation="vertical" className={classes.stepper}>
				{steps.map((step, index) => (
					<Step key={index} active={true}>
						<StepLabel>
							<Typography variant="h6">{step.label}</Typography>
						</StepLabel>
						<StepContent>
							<Typography variant="body1" paragraph>
								{step.description}
							</Typography>
							{index === 0 && (
								<Button variant="contained" color="primary" component={Link} to="/heidi-apps">
									View Applications
								</Button>
							)}
						</StepContent>
					</Step>
				))}
			</Stepper>
		</Paper>
	);
}

export default GettingStarted;
